module.exports = {
  InteractivePlugin: {
    PluginName: "Interactive Plugin",
    display_name: "Interactive",
    flow_items: "Flow Items",
  },
};
